module.exports = __webpack_public_path__ + "media/Tapping Play Button.996f63de.mp3";